import { Component, Input, OnInit } from '@angular/core';
import { IncomeTypeService } from '../income-type.service';
import { IncomeType } from '../income-type';
import { SelectComparisons } from '../../../shared/pipes/select.comparisons';
import { NotificationService } from '../../../shared/notification.service';

@Component({
  selector: 'app-income-type-select',
  templateUrl: 'select.component.html',
})
export class IncomeTypeSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the incomeType to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the income-types currently loaded.
   *
   * @type {IncomeType[]}
   */
  public incomeTypes: IncomeType[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {IncomeTypeService} incomeTypeService
   * @param {NotificationService} notificationService
   */
  constructor(
    private incomeTypeService: IncomeTypeService,
    private notificationService: NotificationService,
  ) {
    super();
    this.incomeTypeService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the incomeType list.
   */
  public ngOnInit(): void {
    this.loadIncomeTypes(1, 10000);
  }

  /**
   * Loads a list of income-types using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadIncomeTypes(page?: number, limit?: number): void {
    const listIncomeTypes = this.incomeTypeService
      .listIncomeTypes(page, limit)
      .subscribe((incomeTypes: IncomeType[]) => {
        this.incomeTypes = incomeTypes;
        listIncomeTypes.unsubscribe();
      });
  }
}
